import { createMultiStyleConfigHelpers } from "@chakra-ui/styled-system";
const { defineMultiStyleConfig } = createMultiStyleConfigHelpers([
    "container",
    "button",
]);
const baseStyle = {
    container: {
        display: "flex",
        position: "relative",
        width: "fit-content",
        alignItems: "center",
    },
    button: {
        display: "flex",
        cursor: "pointer",
        margin: 0,
        height: "1.875rem",
        width: "auto",
        minWidth: "auto",
        py: "0.4375rem",
        px: "0.5rem",
        borderTop: "1px solid",
        borderBottom: "1px solid",
        borderColor: "semantic.border.primary",
        backgroundColor: "none",
        color: "semantic.icon.info",
        _active: {
            backgroundColor: "semantic.cta.secondaryPressed",
            color: "semantic.icon.inverse",
        },
        _focusVisible: {
            backgroundColor: "semantic.cta.secondaryHover",
            borderWidth: "2px",
            borderStyle: "solid",
            borderColor: "semantic.outline.focus",
        },
        _hover: {
            backgroundColor: "semantic.cta.secondaryHover",
        },
        "& > svg": {
            minWidth: "16px",
            minHeight: "16px",
        },
        ".chakra-button__icon": {
            alignItems: "center",
            margin: 0,
        },
        ".chakra-text": {
            paddingLeft: "0.5rem",
        },
        "&._sdxIsSelected": {
            backgroundColor: "semantic.cta.secondaryPressed",
            color: "semantic.icon.inverse",
            _focusVisible: {
                borderWidth: "2px",
                borderStyle: "solid",
                borderColor: "semantic.outline.focus",
            },
            _hover: {
                backgroundColor: "semantic.cta.secondaryPressed",
            },
        },
    },
};
const ButtonToggleTheme = defineMultiStyleConfig({
    baseStyle,
});
export default ButtonToggleTheme;
//# sourceMappingURL=ButtonToggle.default.js.map